import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=07555090&scoped=true"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"
import style0 from "./Review.vue?vue&type=style&index=0&id=07555090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07555090",
  null
  
)

export default component.exports